{
  "name": "@client-outreach/web",
  "private": true,
  "version": "0.5.0-rc.118",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "tsc -b && vite build",
    "typecheck": "tsc -p tsconfig.json --noEmit",
    "preview": "vite preview"
  },
  "dependencies": {
    "@client-outreach/shared": "file:../../packages/shared",
    "firebase": "latest",
    "react": "latest",
    "react-dom": "latest"
  },
  "devDependencies": {
    "@types/react": "latest",
    "@types/react-dom": "latest",
    "@vitejs/plugin-react": "6.1.2",
    "typescript": "5.8.3",
    "vite": "8.3.2"
  }
}
